import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// The module loads on first visit as one section; its screens split further inside it (AiEmployeesSection.tsx)
const AiEmployeesSection = lazyRoute(() => import('./AiEmployeesSection').then((m) => m.AiEmployeesSection));

/** AI employees (the team, test console, analytics, settings), under /agencies/:agencyId/ai_employees */
export const aiEmployeesAgencyRoutes = <Route path="ai_employees/*" element={<AiEmployeesSection />} />;
